module.exports = __webpack_public_path__ + "img/masterOtp.7f8a57ba.svg";